import React from 'react'
import { useTranslation } from 'react-i18next'
import ATTabs from '../../components/layoutComponent/tabs/ATTabs'
import PlantDetails from '../../components/plants/PlantDetails'
import AtTwoColumnLayout from '../../components/layoutComponent/twoColumnLayout/ATTwoColumnLayout'
import PlantList from '../../components/plants/PlantList'
import './Plants.css'
import { PERMISSIONS } from '../../components/common/auth/AuthorizeConstant'
import usePlantHooks from '../../customHooks/plant/usePlantHooks'

const Plants: React.FC = () => {
  const {
    selectedTab,
    selectedPlant,
    selectedPlantDetails,
    filteredList,
    searchedInputValue,
    Tabs,
    showPlantDetailsFormStatus,
    onSearchQueryHandler,
    updateShowPlantDetailFormStatus,
    handleTabSelection,
    handlePlantSelection,
    setSelectedPlant,
  } = usePlantHooks()
  const { t } = useTranslation(['translation'])

  const getJsxConditionally = () => {
    return (
      <AtTwoColumnLayout
        listPanel={
          <PlantList
            list={filteredList}
            selectedTab={selectedTab}
            selectedPlant={selectedPlant}
            handleSelectedItem={handlePlantSelection}
            onSearchQueryHandler={onSearchQueryHandler}
            updateShowPlantDetailFormStatus={updateShowPlantDetailFormStatus}
            showPlantDetailsFormStatus={showPlantDetailsFormStatus}
            searchedInputValue={searchedInputValue}
          />
        }
        detailsPanel={
          <PlantDetails
            data={selectedPlantDetails}
            setSelectedPlant={setSelectedPlant}
          />
        }
        widgetName={PERMISSIONS.VIEW_PLANTS}
      />
    )
  }

  return (
    <div className="plant-container multi-tabs hm-class">
      <p className="plant-title px-3 my-0 py-2">{t('common.plant')}</p>
      <div className="plant-content m-3 mt-0 border bg-white">
        <div className="tabs-wrapper pt-2">
          <ATTabs
            tabDetails={Tabs}
            onTabSelect={handleTabSelection}
            activeKey={selectedTab}
            showIcon={true}
          />
        </div>
        <div className="plant-tab-body">{getJsxConditionally()}</div>
      </div>
    </div>
  )
}

export default Plants
